import { required, maxLength, minLength, alphaNum } from 'vuelidate/lib/validators'

const senhaForte = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /[a-z]/.test(value) && /[A-Z]/.test(value) && (/[0-9]/.test(value) || /[@!#$?%&*]/.test(value))
}


const regexSenha = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /^[a-zA-Z0-9@!#$?&%*]+$/g.test(value)
}


export const validateData = {
  form: {
    description: { required, maxLength: maxLength(30) },
    usuario: { required , maxLength: maxLength(20), minLength: minLength(5), alphaNum},
    dtmf: { required },
    senha: { required, minLength: minLength(8), maxLength: maxLength(20), regexSenha, senhaForte },
  },
}

export const validateComputed = {
  descriptionErrors() {
    const errors = []
    if (!this.$v.form.description.$dirty) return errors
    !this.$v.form.description.required && errors.push('Nome é obrigatório.')
    !this.$v.form.description.maxLength && errors.push('Nome não pode conter mais de 30 caracteres.')
    return errors
  },
  usuarioErrors() {
    const errors = []
    if (!this.$v.form.usuario.$dirty) return errors
    !this.$v.form.usuario.required && errors.push('Usuário é obrigatório.')
    !this.$v.form.usuario.maxLength && errors.push('Usuário não pode conter mais de 20 caracteres.')
    !this.$v.form.usuario.minLength && errors.push('Usuário deve ter no mínimo 5 dígitos.')
    !this.$v.form.usuario.alphaNum && errors.push('Usuário não pode conter espaço em branco')
    return errors
  },
  senhaErrors() {
    const errors = []
    if (!this.$v.form.senha.$dirty) return errors
    !this.$v.form.senha.required && errors.push('Senha é obrigatória.')
    !this.$v.form.senha.minLength && errors.push('Senha deve ter no mínimo 8 dígitos.')
    !this.$v.form.senha.maxLength && errors.push('Senha deve ter no máximo 20 dígitos.')
    !this.$v.form.senha.regexSenha && errors.push('Caractere inválido na senha.')
    !this.$v.form.senha.senhaForte && errors.push('Senha não é forte.')
    return errors
  },
  dtmfErrors() {
    const errors = []
    if (!this.$v.form.dtmf.$dirty) return errors
    !this.$v.form.dtmf.required && errors.push('DTMF é obrigatório.')
    return errors
  },
}
